import React, {useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import useInView from "./utils/useInView";

const Filters = ({dis, title, min, from, to, max}) => {
    const [ref, inView] = useInView();
    const navigate = useNavigate();
    const location = useLocation();
    const [district, setDistrict] = useState(dis || "");
    const [q, setQ] = useState(title || "");
    const [min_price_som, setMinPriceSom] = useState(min || "");
    const [max_price_som, setMaxPriceSom] = useState(max || "");
    const [created_from, setStartDate] = useState(from || "");
    const [created_to, setEndDate] = useState(to || "");


    const handleClear = () => {
        setDistrict("");
        setQ("");
        setMinPriceSom("");
        setMaxPriceSom("");
        setStartDate("");
        setEndDate("");
    };

    const handleClick = (e) => {
        e.preventDefault();

        const state = {
            district,
            q,
            min_price_som,
            max_price_som,
            created_from,
            created_to,
        };

        if (location.pathname === "/detail/profile") {
            navigate("/detail/profile", {state});
        } else {
            navigate("/detail/result", {state});
        }
    };

    return (
        <div
            ref={ref}
            className={`opacity-0 scale-95 transition-all duration-500 ${
                inView ? "opacity-100 scale-100" : ""
            }`}
        >
            <div className="w-11/12 mx-auto pt-12">
                <div className="border border-gray-200 backdrop-blur-md shadow-lg rounded-2xl p-10">
                    <div className="flex items-center justify-center mb-8">
                        <h2 className="text-2xl md:text-3xl font-semibold text-gray-800">
                            Фильтрация объявлений
                        </h2>
                    </div>

                    <form className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {/* Название */}
                        <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-2">
                                Поиск по названию
                            </label>
                            <input
                                type="text"
                                value={q}
                                onChange={(e) => setQ(e.target.value)}
                                placeholder="Введите название"
                                className="w-full border placeholder:text-gray-500 border-gray-300 bg-white/30 focus:bg-white/50 focus:border-blue-600 focus:ring-1 focus:ring-blue-600 rounded-lg px-4 py-2 text-sm text-gray-800 outline-none transition"
                            />
                        </div>

                        {/* Район */}
                        <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-2">
                                Район
                            </label>
                            <input
                                type="text"
                                value={district}
                                onChange={(e) => setDistrict(e.target.value)}
                                placeholder="Введите район"
                                className="w-full border border-gray-300 placeholder:text-gray-500 bg-white/30 focus:bg-white/50 focus:border-blue-600 focus:ring-1 focus:ring-blue-600 rounded-lg px-4 py-2 text-sm text-gray-800 outline-none transition"
                            />
                        </div>

                        {/* Цена */}
                        <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-2">
                                Фильтр по цене <span className="text-xs text-gray-500">(сом)</span>
                            </label>
                            <div className="flex gap-3">
                                <input
                                    type="number"
                                    value={min_price_som}
                                    onChange={(e) => setMinPriceSom(e.target.value)}
                                    placeholder="Мин."
                                    className="w-1/2 border border-gray-300 placeholder:text-gray-500 bg-white/30 focus:bg-white/50 focus:border-blue-600 focus:ring-1 focus:ring-blue-600 rounded-lg px-4 py-2 text-sm text-gray-800 outline-none transition"
                                />
                                <input
                                    type="number"
                                    value={max_price_som}
                                    onChange={(e) => setMaxPriceSom(e.target.value)}
                                    placeholder="Макс."
                                    className="w-1/2 border border-gray-300 placeholder:text-gray-500 bg-white/30 focus:bg-white/50 focus:border-blue-600 focus:ring-1 focus:ring-blue-600 rounded-lg px-4 py-2 text-sm text-gray-800 outline-none transition"
                                />
                            </div>
                        </div>

                        {/* Дата */}
                        <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-2">
                                Фильтр по дате
                            </label>
                            <div className="flex gap-3">
                                <input
                                    type="date"
                                    value={created_from}
                                    onChange={(e) => setStartDate(e.target.value)}
                                    className="w-1/2 border border-gray-300 placeholder:text-gray-500 bg-white/30 focus:bg-white/50 focus:border-blue-600 focus:ring-1 focus:ring-blue-600 rounded-lg px-4 py-2 text-sm text-gray-800 outline-none transition"
                                />
                                <input
                                    type="date"
                                    value={created_to}
                                    onChange={(e) => setEndDate(e.target.value)}
                                    className="w-1/2 border border-gray-300 placeholder:text-gray-500 bg-white/30 focus:bg-white/50 focus:border-blue-600 focus:ring-1 focus:ring-blue-600 rounded-lg px-4 py-2 text-sm text-gray-800 outline-none transition"
                                />
                            </div>
                        </div>

                        {/* Кнопки */}
                        <div className="flex gap-4 items-end">
                            <button
                                type="button"
                                onClick={handleClick}
                                className="flex-1 text-sm md:text-base bg-blue-600 hover:bg-blue-700 text-white font-medium py-2.5 rounded-lg transition focus:ring-2 focus:ring-blue-400 focus:ring-offset-1"
                            >
                                Применить
                            </button>
                            <button
                                type="button"
                                onClick={handleClear}
                                className="flex-1 text-sm md:text-base border border-gray-300 text-gray-700 bg-white/30 hover:bg-white/50 font-medium py-2.5 rounded-lg transition"
                            >
                                Очистить
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Filters;
